import axios from 'axios';
import { isValidPromoCode } from '../utils/promoCode';

const auth = () => {
  const token = localStorage.getItem('token');
  return { headers: token ? { Authorization: token } : {} };
};
const unwrap = response => {
  if (response.data?.isError) throw new Error(response.data.errorMessage || 'Не вдалося застосувати промокод');
  return response.data?.data;
};
export const previewPromo = (body, isAdmin = false) => {
  if (!isValidPromoCode(body.promoCode)) return Promise.reject(new Error('Такого промокоду немає'));
  return axios.post(`/api/v1/order/${isAdmin ? 'admin-promo-preview' : 'promo-preview'}`, body, auth()).then(unwrap);
};
export const changeOrderPromo = (orderId, code) => {
  if (code && !isValidPromoCode(code)) return Promise.reject(new Error('Такого промокоду немає'));
  return axios.put(`/api/v1/order/${orderId}/promo-code`, { code }, auth()).then(unwrap);
};
export const listPromoCodes = (options = {}) => {
  const params = new URLSearchParams();
  Object.entries({ limit: 25, offset: 0, sortBy: 'id', sortOrder: 'desc', ...options }).forEach(([key, value]) => {
    (Array.isArray(value) ? value : [value]).forEach(item => {
      if (item != null && item !== '') params.append(key, String(item));
    });
  });
  return axios.get('/api/v1/admin/promo-codes', { ...auth(), params })
    .then(response => ({ items: unwrap(response) || [], total: response.data?.totalNumber || 0 }));
};
export const savePromoCode = promo => (promo.id
  ? axios.put(`/api/v1/admin/promo-codes/${promo.id}`, promo, auth())
  : axios.post('/api/v1/admin/promo-codes', promo, auth())
).then(unwrap);
export const fetchPromoHistory = (id, offset = 0) => axios.get(`/api/v1/admin/promo-codes/${id}/redemptions`, {
  ...auth(), params: { limit: 50, offset },
}).then(unwrap);
export const fetchPromoAssignedUser = id => axios.get(`/api/v1/admin/promo-codes/${id}/assigned-user`, auth()).then(unwrap);


export const fetchPromoWheel = () => axios.get('/api/v1/user/promo-wheel', auth()).then(unwrap);
export const spinPromoWheel = () => axios.post('/api/v1/user/promo-wheel/spin', {}, auth()).then(unwrap);
export const fetchWheelCampaign = () => axios.get('/api/v1/admin/promo-wheel/campaign', auth()).then(unwrap);
export const saveWheelCampaign = campaign => axios.put('/api/v1/admin/promo-wheel/campaign', campaign, auth()).then(unwrap);
